import { FC } from 'react'
import { Icon } from '@iconify/react'

import s from './Suffix.module.css'

type Props = {
  type: 'loading' | 'checked'
}

export const Suffix: FC<Props> = ({ type }) => {
  return type === 'checked' ? (
    <Icon icon="lucide:check-circle-2" width="18" className={s.accessible} />
  ) : (
    <div className={s.loading} />
  )
}
